// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__t1OeQ","selected":"styles_selected__2ge16"};